import React, { useRef, useEffect } from 'react';
import { Animated, StyleSheet } from 'react-native';
import Button from '../components/MenuButtonBlock';

export const BounceAnimation = ({ trigger }) => {
  const bounceValue = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    if (trigger) {
      Animated.sequence([
        Animated.timing(bounceValue, {
          toValue: -25,
          duration: 100,
          useNativeDriver: true,
        }),
        Animated.timing(bounceValue, {
          toValue: 0,
          duration: 150,
          useNativeDriver: true,
        }),
        Animated.timing(bounceValue, {
          toValue: -15,
          duration: 150,
          useNativeDriver: true,
        }),
        Animated.timing(bounceValue, {
          toValue: 0,
          duration: 150,
          useNativeDriver: true,
        }),
        Animated.timing(bounceValue, {
          toValue: -5,
          duration: 150,
          useNativeDriver: true,
        }),
        Animated.timing(bounceValue, {
          toValue: 0,
          duration: 150,
          useNativeDriver: true,
        }),
      ]).start();
    }
  }, [trigger, bounceValue]);

  return (
    <Animated.View
      style={[
        {
          transform: [
            {
              translateY: bounceValue,
            },
          ],
        },
      ]}
    >
      <Button />
    </Animated.View>
  );
};
